/* eslint-disable */
import Swiper, { Autoplay, EffectCoverflow, Navigation } from 'swiper';

export default {
  init() {
    // JavaScript to be fired on all pages

    /**
     * Mobile (mega)) menu
     */

    $('.mega-menu--trigger').on('click', function () {
      $('.mobile-hamburger-icon').toggleClass('mobile-hamburger-icon--active');
      $('.mega-menu').toggleClass('mega-menu--active');
      $('.site-header').toggleClass('site-header--active');
      // $('.replacement-block').toggleClass('replacement-block--active');
    })


    if ($('.swiper-featured-slider').length) {

      Swiper.use([Navigation, EffectCoverflow, Autoplay]);

      new Swiper('.swiper-featured-slider', {
        effect: 'coverflow',
        slidesPerView: 3,
        // spaceBetween: 30,
        grabCursor: true,
        centeredSlides: true,
        loop: true,
        coverflowEffect: {
          rotate: 0,
          stretch: -50,
          depth: 300,
          modifier: 2.2,
          slideShadows: false,
        },
        autoplay: {
          delay: 2500,
        },
        navigation: {
          nextEl: '.swiper-featured-button-next',
          prevEl: '.swiper-featured-button-prev',
        },
      });
    }
    /**
     * 
     * Search modal
     * 
    */

    $('.search--trigger').on('click', function () {
      $('.search-modal').addClass('search-modal--active');
    });
    $('.search-modal').on('click', function () {
      $(this).removeClass('search-modal--active');
    });

    $('.search-form').on('click', function (e) {
      e.stopPropagation();
    });

    //woocommerce

    $('.filterbutton').on('click', function () {
      $('.archive-product__sidebar').addClass('archive-product__sidebar--active');
      $('.darkoverlay').addClass('darkoverlay--active');
    });

    $('.filter--exit, .darkoverlay').on('click', function () {
      $('.archive-product__sidebar').removeClass('archive-product__sidebar--active');
      $('.darkoverlay').removeClass('darkoverlay--active');
    });

    function setCookie(name, value, expiry) {
      let d = new Date();
      d.setTime(d.getTime() + (expiry * 86400000));
      document.cookie = name + "=" + value + ";" + "expires=" + d.toUTCString() + ";path=/";
    }

    function getCookie(name) {
      let cookie = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return cookie ? cookie[2] : null;
    }

    function eatCookie(name) {
      setCookie(name, "", -1);
    }

    function noScroll() {
      window.scrollTo(0, 0);
    }

    if (getCookie('age_confirmation') !== 'confirmed') {
      $('.age-popup').css('display', 'flex');
      window.addEventListener('scroll', noScroll);
    }

    $('.age-popup__confirm').on('click', () => {
      const expDate = new Date()
      expDate.setDate(expDate.getDate() + 30);

      setCookie('age_confirmation', 'confirmed', expDate)

      window.removeEventListener('scroll', noScroll);
      $('.age-popup').hide();
    })

        
    $('.verpakking-checkbox').on('change', (e) => {
        let product_id = e.target.value;

        console.log(product_id)

        if(e.target.checked) { //add product event
            var verpakkingData = {
                action: 'add_verpakking',
                product_id: product_id, //the id
            };

        } else {
            var verpakkingData = {
                action: 'remove_verpakking',
                product_id: product_id, //the id
            };
        }

        $.ajax({
            type: 'post',
            dataType: 'json',
            url: '/wp-admin/admin-ajax.php',
            data: verpakkingData,
            beforeSend: function () {
                $('#checkoutVerpakkingen').addClass('disabled');
            },
            success: function(data){
              setTimeout(function() { 
                  $('#checkoutVerpakkingen').removeClass('disabled');
                  console.log(data)
                  $( 'body' ).trigger( 'update_checkout' );
              }, 300);
                
            },
            error: function(e) {
              console.log('This is not good: ' + e);
            },
        });
    })
        
    
    $('#checkbox_trigger_field').on('change', () => {
        $('#wenskaart_field_field').fadeToggle();
    })
        
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js